<template>
    <div v-show="isShow">
        <div v-b-toggle.sidebar-right class="hamberger-bar cursor-pointer" @click="clickMenu()">
            <div class="hamberger-icon"></div>
            <div class="hamberger-icon"></div>
            <div class="hamberger-icon"></div>
        </div>
        <b-sidebar id="sidebar-right" right shadow backdrop @hidden="clickClose()">
            <div class="px-3 py-2 text-center">
                <img src="@/assets/img/01-register/logo-big@2x.png" class="img-logo" fluid thumbnail>
                <div class="menu">
                    <div v-for="(menu, index) in menus" :key="index" class="cursor-pointer" @click="goToMenu(menu.path)">
                        {{ menu.name }}
                        <div class="line"></div>
                    </div>
                </div>
            </div>
            <div class="cancel-membership">
                <div class="cursor-pointer text-underline" @click="onClickCancelMembership()">Cancel membership</div>
                <div class="line"></div>
                <div>
                    <img src="@/assets/img/01-register/buzzebees-logo@2x.png" class="bz-logo" fluid thumbnail>
                </div>
            </div>
        </b-sidebar>
  </div>
</template>

<script>
import { TrackingService } from "@/helper/TrackingHelper";
export default {
    name: 'Menusidebar',
    props:{
        isShow: Boolean
    },
    data: function() {
        return {
            menus: [
                {
                    name: 'Terms & Conditions',
                    path: '/termsandconditions'
                },
                {
                    name: 'Privacy Policy',
                    path: '/privacy'
                },
                {
                    name: 'Contact us',
                    path: '/contactus'
                }
            ],
            tracking: new TrackingService(this)
        };
    },
    created: function() {
        this.tracking.screenName('Menu');
    },
    methods: {
        onClickCancelMembership: function(){
            this.$emit('clickMembership');
            this.tracking.event('menu', 'click_Cancel_member');
        },
        goToMenu: function(path){
            this.$router.push(path)
            switch (path) {
                case '/termsandconditions':
                   this.tracking.event('menu', 'click_term_and_con');
                   break;
                case '/privacy':
                   this.tracking.event('menu', 'click_Privacy_Policy');
                   break;
                case '/contactus':
                   this.tracking.event('menu', 'click_Contact_us');
                   break;
            }
        },
        clickMenu: function(){
            this.tracking.event('menu', 'click_menu');
        },
        clickClose: function() {
            this.tracking.event('menu', 'click_close');
        }
    },
};
</script>

<style lang="scss" scoped>
.img-logo{
    width: 130px;
}
.bz-logo{
    width: 100px;
}
.menu{
    font-size: 20px;
    text-align: center;
    padding-top: 52px ;
}
.line{
  height: 0.8px;
  background-color: #ccc;
  margin: 20px;
}
.hamberger-icon {
  width: 30px;
  height: 4px;
  background-color: white;
  margin: 6px 0;
}
.hamberger-bar{
    margin-right: 20px;
    padding-top: 5px;
}
.cancel-membership{
    font-size: 13px;
    text-align: center;
    position: absolute;
    bottom: 15px;
    width: 100%;
}
</style>
